import {inject} from '@angular/core';
import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {throwError} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {AuthenticationService} from './authentication.service';
import {LOGIN_URL} from "../../models/home/navigation.model";
import {environment} from "../../../environments/environment";

export const globalHttpInterceptor: HttpInterceptorFn = (req, next) => {
	const router = inject(Router);
	const authenticationService = inject(AuthenticationService);

	return next(req).pipe(
		catchError((error) => {
			if (!(error instanceof HttpErrorResponse)) {
				console.error("Other Errors", error);
				return throwError(() => error);
			}
			if (error.error instanceof ErrorEvent) {
				console.error("Error Event", error);
				return throwError(() => error);
			}
			console.error(`Error status : ${error.status} ${error.statusText}`);
			if (error.status !== 401 || req.url.startsWith(environment.engineURL + '/authenticate')) {
				return throwError(() => error);
			}
			// Expired access token: renew it once with the refresh token and replay the request.
			// Only a failed refresh (none stored, outdated, revoked) or a fresh token refused again ends the session;
			// any other failure of the replay (403, 404, 5xx) reaches the caller as it is.
			const endSession = (cause: HttpErrorResponse) => {
				authenticationService.logout();
				setTimeout(() => router.navigateByUrl(LOGIN_URL));
				return throwError(() => cause);
			};
			return authenticationService.refreshAccessToken().pipe(
				catchError(() => endSession(error)),
				switchMap(token => next(req.clone({setHeaders: {Authorization: 'Bearer ' + token}})).pipe(
					catchError(replayError => replayError instanceof HttpErrorResponse && replayError.status === 401
						? endSession(replayError)
						: throwError(() => replayError)),
				)),
			);
		})
	);
};
